export default __webpack_public_path__ + "static/media/twitter.b67f573e.svg";